// src/utils/formatNumber.js

export const formatNumber = (number) => {
    // Sayıyı önce tam sayı ve desimal kısımlarına ayır
    const [integerPart, decimalPart] = number.toString().split('.');
  
    // Binlik ayraç olarak nokta eklemek için
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
    // Eğer decimal kısmı varsa, virgül ile birleştir
    if (decimalPart) {
      // Desimal kısmına virgül ekle
      const formattedDecimal = decimalPart.slice(0, 2); // Virgülden sonra 2 basamağı al
      return `${formattedInteger},${formattedDecimal}`;
    }
  
    // Eğer decimal kısmı yoksa sadece tam sayı kısmı dön
    return formattedInteger;
  };
  